import { Component, OnInit } from '@angular/core';
import { getpublicportalsectionscontactusbyid_webportal } from 'src/app/core/models/getpublicportalsectionscontactusbyid_webportal';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  objgetpublicportalsectionscontactusbyid_webportal:getpublicportalsectionscontactusbyid_webportal
  totalPages: any;
  totalRecords: any;
  pages: any[];
  Records: any;
  Section1Array: any;
  Section2Array: any;
  Section3Array: any;
  Section4Array: any;
  Section5Array: any;
  Section6Array: any;
  Name: any;
  Description: any;
  SectionID: any;
  PhoneNumber: any;
  Email: any;
  arrayListSection1: any[] = [];
  arrayListSection2: any[] = [];
  arrayListSection3: any[] = [];
  arrayListSection4: any[] = [];
  arrayListSection5: any[] = [];
  arrayListSection6: any[] = [];
  constructor(public userUtilsService:UserUtilService,public publicPortalService:PublicPortalService) { }

  ngOnInit(): void {
    this.objgetpublicportalsectionscontactusbyid_webportal=new getpublicportalsectionscontactusbyid_webportal()
    this.getpublicportalsectionscontactusbyid_webportal()
  }
  getpublicportalsectionscontactusbyid_webportal(){
    this.objgetpublicportalsectionscontactusbyid_webportal.ID=0
    this.publicPortalService.getpublicportalsectionscontactusbyid_webportal(this.objgetpublicportalsectionscontactusbyid_webportal)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any);
              this.Records = data
              this.Section1Array = this.Records.filter(item => item.SectionID === 19);
              this.Section2Array = this.Records.filter(item => item.SectionID === 20);
              this.Section3Array = this.Records.filter(item => item.SectionID === 21);
              this.Section4Array = this.Records.filter(item => item.SectionID === 22);
              this.Section5Array = this.Records.filter(item => item.SectionID === 23);
              this.Section6Array = this.Records.filter(item => item.SectionID === 24);
            }
          }
        }
      })
  }
}
